import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '@shared/abstract.service';
import { HttpClient } from '@angular/common/http';
import { SERVICES, HTTP_METHODS } from '@root/constant';
import { EncryptionProviderService } from '@shared/encryption.service';

const URL = SERVICES.INVESTOR_LIST.PATH;
const DEFAULT_PAGE_SIZE=500;

@Injectable()
export class InvestorListService extends AbstractService<any> {
  constructor(
    http: HttpClient,

    encryptionProviderService: EncryptionProviderService
  ) {
    super(http, URL, encryptionProviderService);
    this.encryptionProviderService = encryptionProviderService;
  }

  public getInvestorList(data: any, pageNumber:number=1, pageSize:number=DEFAULT_PAGE_SIZE, query:string): Observable<any> {
    let url = `${this.url}investorlist?pagenum=${pageNumber}&numrecords=${pageSize}`;
    if(query){
      url = `${this.url}investorlist?srch=${query}&pagenum=${pageNumber}&numrecords=${pageSize}`;
    }
    return this.request({
      method: HTTP_METHODS.POST,
      url: url,
      body: data,
    });
  }


  public blockInvestor(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}blockinvestor`,
      body: data,
    });
  }

}
